import React from 'react';
import { loadConnectAndInitialize } from '@stripe/connect-js';
import { STRIPE_PK } from '../../constants/stripe';
import useUser from '../global/useUser';
import { createBusinessStripeAccountSession } from '../../services/business';
import useStripeOptions from './useStripeOptions';
import { canManageStripeAccount } from '../../helpers/businesses';

function useStripeAccountSession() {
  const { user } = useUser();
  const stripeOptions = useStripeOptions();

  const hasAccess = canManageStripeAccount(user);

  const fetchClientSecret = React.useCallback(async () => {
    if (!user?.business || !hasAccess)
      throw new Error('User does not have access to Stripe account');
    const session = await createBusinessStripeAccountSession(user.business.id!);
    return session.client_secret;
  }, [user?.business, hasAccess]);

  const connect = React.useMemo(
    () =>
      hasAccess
        ? loadConnectAndInitialize({
            publishableKey: STRIPE_PK!,
            fetchClientSecret,
            ...stripeOptions,
          })
        : null,
    [hasAccess, fetchClientSecret, stripeOptions],
  );

  return connect;
}

export default useStripeAccountSession;
